let win;
if (typeof window === 'undefined') {
  win = { location: {} };
} else {
  win = window;
}

/* eslint max-len: [0] */
export const HOSTNAME = `//${process.env.JAWS_URL || win.location.host}`;
export const BASE_URL = `${HOSTNAME}/server`;
export const SECURE_BASE_URL = `${HOSTNAME}/server/secure`;
export const DOMAIN_URL = `${BASE_URL}/domain/`;
export const COMPONENTS_URL = `${SECURE_BASE_URL}/components`;
export const SUGGEST_URL = `${BASE_URL}/suggest`;
export const GRAPHDATA_URL = `${BASE_URL}/components/graphdata`;
export const WATCHLIST_URL = `${BASE_URL}/secure/watchlists`;

export const TRANSACTIONS_URL = `${SECURE_BASE_URL}/transactions`;

export const CUSTOMERS_URL = `${BASE_URL}/rest/customers`;

export const EXCHANGE_URL = `${BASE_URL}/rest/exchange`;

export const SESSION_KEEPALIVE_URL = `${BASE_URL}/rest/keepalive`;
export const USER_INFO_URL = `${BASE_URL}/rest/me`;

export const SNIPLETS_URL = `${BASE_URL}/rest/sniplets`;

export const REPORTS_URL = `${BASE_URL}/rest/reports`;
export const REPORT_RECOMMENDATION_TYPES_URL = `${BASE_URL}/rest/recommendation-type`;
export const COMPANY_REPORTS_URL = `${BASE_URL}/rest/company-reports`;
export const COMPANY_REPORT_SUBTYPES_URL = `${BASE_URL}/rest/company-report-subtype`;
export const INSTRUMENTSET_URL = `${BASE_URL}/rest/instruments/sets`;

export const ADMIN_LOGIN_URL = `${BASE_URL}/rest/admin/login`;
export const ADMIN_LOGOUT_URL = `${BASE_URL}/rest/admin/logout`;
export const ADMIN_CHANGE_PW_URL = `${BASE_URL}/rest/admin/change-password`;
export const ADMIN_USERS_URL = `${BASE_URL}/rest/admin`;
export const ADMIN_CUSTOMERS_URL = `${BASE_URL}/rest/admin/customers`;

export const ADMIN_AUDIT_STATS_URL = `${BASE_URL}/rest/audit/auditStats`;
export const ADMIN_AUDIT_SEARCH_URL = `${BASE_URL}/rest/audit/search`;
export const ADMIN_AUDIT_GRAPH_STATS_URL = `${BASE_URL}/rest/audit/graphStats`;

export const ALERTS_URL = `${BASE_URL}/secure/jaws-alerts`;

export const PORTFOLIOS_URL = `${BASE_URL}/secure/portfolios`;
export const FICTIVE_PORTFOLIOS_URL = `${PORTFOLIOS_URL}/fictive`;
export const PORTFOLIO_INSTRUMENTS_URL = `${PORTFOLIOS_URL}/instruments`;
export const CURRENCY_EXCHANGE_RATES_URL = `${BASE_URL}/rest/currencyExchangeRates`;
